import { apiGet, apiPost, apiUpdate } from "../http";

export default {
  async filterFlashSalesAPI(filter) {
      return await apiPost(`api/flashSales/filter`, filter);
  },
  async putWholesalePricesAPI(data) {
    return await apiUpdate("api/flashSales/wholeSalePrice", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async getSizesAPI(data) {
    return await apiPost("api/flashSales/getSizes", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async getSpreadsheetAPI(data) {
    return apiPost("api/flashSales/getSpreadSheet", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async exportFlashSalesAPI(data) {
    return await apiPost("api/flashSalesExport", data)
  },
  async checkGoogleTokenAPI() {
    return await apiGet(`api/google/checkAuth`)
  },
  async postNewTokenAPI(data) {
    return await apiPost(`api/google/newToken`, data)
  }
};
